import * as dealInfoHelpers from '@wix/wix-vod-shared/dist/src/common/utils/deal-info-helpers.js';
export default function getTranslationData(channel) {
    return {
        props: 'widget.overlay-buttons.get-subscription',
        priceModel: dealInfoHelpers.getSubscriptionPriceInfo(channel.dealInfo),
    };
}
